import { useQuery } from "@tanstack/react-query";
import egam from "../../services/egam";
import { getClientData } from "../../services/auth";
import { queryKeys } from "../api/queryKeys";

interface ClockConfig {
  atual: number; // timestamp em segundos
  max: string; // formato "HH:mm"
}

interface ClockData {
  config: ClockConfig;
}

export const useClock = (enabled: boolean = true) => {
  return useQuery<ClockData>({
    queryKey: queryKeys.clock(),
    queryFn: async () => {
      const clientData = getClientData();
      if (!clientData) {
        throw new Error("Cliente não autenticado");
      }
      const response = await egam.get<ClockData>("relogio");

      if (response.status !== 200) {
        throw new Error("Não foi possível capturar configurações do relógio");
      }

      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutos
    refetchInterval: 5 * 60 * 1000, // Refetch a cada 5 minutos
  });
};
